var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPercentIcon = function SvgPercentIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#292C31",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M25 7 7 25"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#292C31",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M9.5 13a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7ZM22.5 26a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Z"
  })));
};
export default SvgPercentIcon;